// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* heading-3 style same as rich content style */\n.field-component .field-label {\n  margin-bottom: 0;\n  font-size: 1.1rem;\n  font-weight: bold;\n}\n.field-component .field-value {\n  font-size: 16px;\n  line-height: 160%;\n  color: var(--textFontColor, inherit);\n  font-weight: var(--textFontWeight, inherit);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
